
export { default as compose } from "./compose.js"
export { default as map } from "./map.js"
export { default as propOr } from "./propOr.js"